import { render } from "./EventTablaStaff.vue?vue&type=template&id=4ba0890f&scoped=true"
import script from "./EventTablaStaff.vue?vue&type=script&lang=js"
export * from "./EventTablaStaff.vue?vue&type=script&lang=js"

import "./EventTablaStaff.vue?vue&type=style&index=0&id=4ba0890f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ba0890f"]])

export default __exports__